import { render, staticRenderFns } from "./siteInfo.vue?vue&type=template&id=54aaa37d&scoped=true&"
import script from "./siteInfo.vue?vue&type=script&lang=js&"
export * from "./siteInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54aaa37d",
  null
  
)

export default component.exports